<div class="list-for-reorder-items">
    <div class="list-for-reorder-items__inner">
        <ng-container *ngFor="let orderItem of reorderItems | limit:limit;trackBy: trackBy;">

            <div directive-max-on-screen-height="item" [registerId]="maxOnScreenHeight || null"
                [subRegisterId]="maxOnScreenHeight ? maxOnScreenHeight+'-order-item-'+orderItem.Id : null"
                class="list-for-reorder-items__item">

                <shared-tile-for-reorder-product-item (onSelected)="handleSelected($event)"
                    (onDeselected)="handleDeselected($event)" [bottomPadding]="bottomPadding" [orderItem]="orderItem"
                    class="list-for-reorder-items__tile">
                </shared-tile-for-reorder-product-item>
            </div>

        </ng-container>

    </div>
</div>